import CryptoJS from 'crypto-js';
import config from '../config';

export const encrypt = (messageToEncrypt: string): string => CryptoJS.AES.encrypt(messageToEncrypt, config.encryption.secret).toString();

export const decrypt = (encryptedMessage: string): string => {
  const bytes = CryptoJS.AES.decrypt(encryptedMessage, config.encryption.secret);
  return bytes && bytes.toString(CryptoJS.enc.Utf8);
};
